import React from 'react';
import {useCart} from "../utilities/context/cart/cart-context";

const BuySubBtnsPanel = ({product, trialProduct}) => {

    const {addToCart} = useCart();

    const handleClick = () => {
        addToCart(product);
    }

    const handleClickTrial = () => {
        addToCart(trialProduct)
    }

    return (
        <div className="bg-yellow-100 flex-3 p-6 rounded-br-lg flex flex-col justify-center">
            <div className="mb-8">
                <span className="text-8xl font-bold">{product.price}</span>
                <span>,00€ + IVA</span>
            </div>
            <div className="mb-10">Praticamente meno di 2€ a settimana</div>

            <div className="flex flex-col md:flex-row items-center justify-center">
                <button onClick={handleClickTrial} className="p-2 my-4 md:my-0 md:mr-4 shadow-lg rounded-lg uppercase bg-white text-black">
                    prova gratis per <br />
                    15 giorni
                </button>
                <button onClick={handleClick} className="p-2 shadow-lg rounded-lg uppercase bg-gray-600 text-white whitespace-none">
                    Aggiungi questo <br />
                    pacchetto al carrello</button>
            </div>
        </div>
    )
}

export default BuySubBtnsPanel;